export const doNothing = (): void => {};
